
import type { LocationQuery } from 'vue-router';

import type { SearchParams} from '../search/functions';
import { getSearchFromQuery, getSearchToQuery } from '../search/functions';

import { SortOrder } from '@/graphql/generated/graphql';

export interface OrderSearchParams<ColumnKey extends string = string> extends SearchParams {
  orderBy?: [
    {
      column: ColumnKey;
      order: SortOrder;
    }
  ];
}

export interface OrderSearchParamsToQuery<ColumnKey extends string = string> extends SearchParams {
  column?: ColumnKey;
  order?: SortOrder;
}

export function getSearchOrderFromQuery<ColumnKey extends string>(
  query: LocationQuery,
): OrderSearchParams<ColumnKey> {
  const pagination = getSearchFromQuery(query);
  const { order, column } = query;
  if (
    typeof column === 'string'
    && column
    && (order === SortOrder.Asc || order === SortOrder.Desc)
  ) {
    return {
      ...pagination,
      orderBy: [
        {
          column: column as ColumnKey,
          order,
        },
      ],
    };
  }
  return pagination;
}

export const getSearchOrderToQuery = <ColumnKey extends string>(
  params: OrderSearchParams<ColumnKey>,
): OrderSearchParamsToQuery<ColumnKey> => {
  const pagination = getSearchToQuery(params);
  const { orderBy } = params;
  if (orderBy) {
    return {
      ...pagination,
      order: orderBy[0].order,
      column: orderBy[0].column,
    };
  }
  return pagination;
};
